module.exports = __webpack_public_path__ + "img/home.07f2e799.png";